export const SET_ATTENDANCE = "ATTENDANCE/SET_ATTENDANCE";
export const SET_GUICHESPANEL = "GUICHESPANEL/SET_GUICHESPANEL";
export const SET_CURRENTPASSWORDS = "CURRENTPASSWORDS/SET_CURRENTPASSWORDS";
